import React, { useMemo } from "react";
import Dashboard from "components/dashboard";
import { PageSection, PageHeaderBar } from "components/page";
import { useQuery, QueryResponseHandler } from "components/graphql";
import { getContractQuery, ContractData, ActionButtons } from "./details-page";
import { Restricted, permissions } from "components/auth";
import { RoomTemplatePaginatedTable, ActionButtons as RoomTemplatesActionButtons } from "pages/room-template";
import { parsePage } from "components/table";
import { useCurrentCustomerContext } from "components/current-customer-context";
import { deleteContractMutation } from "./table";

const formatTiiviiOttConfig = contract => {
  if (!!contract && !contract?.tiiviiOttConfig) {
    const formattedContract = {...contract};
    formattedContract.tiiviiOttConfig = {
          enabled: false,
          webhookUrl: '',
          nimbleConfigUrl: ''
    }
    return formattedContract;
  }
  return contract;
};

const ContractDetailsPage = ({
  match: {
    params: { id },
  },
  location: { search },
  history,
}) => {
  const { currentCustomerId } = useCurrentCustomerContext();
  const query = useMemo(() => getContractQuery(id), [id]);
  const { data, loading, error } = useQuery(query);

  const contract = formatTiiviiOttConfig(data.contract);

  const contractName = contract ? contract.name : "";

  const roomTemplatesActionButtons = <RoomTemplatesActionButtons contractId={id} />;

  return (
    <Dashboard>
      <QueryResponseHandler error={error} loading={loading} elements={contract}>
        <PageHeaderBar
          showBackButton
          title="app.page.contract.details.title"
          titleParams={{ contractName: contract ? contract.name : null }}
          buttons={
            <ActionButtons
              id={id}
              customerId={currentCustomerId}
              name={contractName}
              mutation={deleteContractMutation}
              history={history}
            />
          }
        />
        <PageSection>
          <ContractData contract={contract} />
        </PageSection>
        <Restricted permissions={[permissions.roomtemplate_view]}>
          <PageHeaderBar subtitle title="app.page.roomTemplates" buttons={roomTemplatesActionButtons} />
          <PageSection spaced hideBackground>
            <RoomTemplatePaginatedTable
              pageName="roomTemplatesPage"
              page={parsePage({ queryParams: search, pageName: "roomTemplatesPage" })}
              variables={{ contractId: id }}
            />
          </PageSection>
        </Restricted>
      </QueryResponseHandler>
    </Dashboard>
  );
};

export default ContractDetailsPage;
